"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    background: palette.elDivider,
    switcherBackground: palette.elPrimary,
    fontSize: palette.tsNormal,
    fontFamily: palette.fontFamily,
    lineHeight: 1.5,
    color: palette.tLabel,
    switcherBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    // elAccent 0.5
    checkedBackground: 'rgba(139, 195, 74, 0.5);',
    checkedSwitcherBackground: palette.elAccent,
    switcherCheckedBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    checkedColor: palette.tFilled,
    checkedHoverColor: palette.tActive,
    hoverColor: palette.tInactive,
    disabledColor: palette.tDisabled
  };
}